// eslint-disable-next-line
// @ts-nocheck this file will be deleted in a follow up PR after BM work is finished
import React, { useContext, memo } from 'react'
import { Platform } from 'react-native'

import { Images } from 'APP/Themes'

import { ChatContext, PostContext } from 'APP/Lib/Context'
import { channelToTimeStampForNewPost } from 'APP/Lib/MessagingHelpers'
import { useDispatch } from 'APP/Hooks/redux'
import PatientHistoryActions from 'APP/Redux/PatientHistoryRedux'
import Analytics from 'APP/Services/Analytics'
import Card from 'APP/Components/Chat/Card'
import { handleMicroAppNavigation } from 'APP/Lib/MicroAppNavHelper'

const MicroApp = () => {
  const { onMessageSend, channelId, userId, conversation } = useContext(ChatContext)
  const { post } = useContext(PostContext)
  const title = post.message

  const id = post.props?.microapp?.id
  const dispatch = useDispatch()

  // if id equals cliniaHealthNavigation, then we should use the self-navigation screen
  const isSelfNavigation = id === 'cliniaHealthNavigation'

  const onPress = () => {
    handleMicroAppNavigation(
      isSelfNavigation,
      {
        microAppProps: { id, ...microAppProps },
        title,
      },
      () =>
        Analytics.trackEvent('button_click', {
          button_value: `Open microapp ${id}`,
        }),
      'microAppDrawer'
    )
  }

  const sendAnswer = (reply) => {
    const { answer_flags, payload, display, question_type } = reply
    const timeStamp = channelToTimeStampForNewPost(conversation)

    dispatch(
      PatientHistoryActions.submitAnswerPostRequest(
        channelId,
        userId,
        {
          question_type,
          text: display,
          data: payload,
        },
        timeStamp,
        answer_flags
      )
    )
    dispatch(PatientHistoryActions.updateChannelLastViewed(channelId))
  }

  const microAppProps = {
    appId: id,
    displayMode: Platform.OS === 'android' ? 'fullscreen' : 'drawer',
    post,
    userId: post.user_id,
    messageFormat: 'mattermost',
    sendText: onMessageSend,
    sendAnswer,
  }

  // For backwards compatibility
  const imageKey = isSelfNavigation ? 'selfNavigation' : 'appointmentBooking'

  return <Card title={title} iconSrc={Images[imageKey]} onPress={onPress} testID="MICROAPP_CARD" />
}

export default memo(MicroApp)
